import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, documentoInfracao } from './types';

export const INITIAL_STATE: documentoInfracao = {
	status: 0,
	data: null,
};

export default function documentoInfracaoReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): documentoInfracao {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_DOCUMENTO_INFRACAO: {
				break;
			}
			case Types.CONSULTA_DOCUMENTO_INFRACAO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_DOCUMENTO_INFRACAO_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CONSULTA_DOCUMENTO_INFRACAO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
	});
}
